import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Flex } from "components/common/Responsive";
import styled from "styled-components";
import SocialIcons from "components/common/SocialIcons";
import ImageWrapper from "components/common/ImageWrapper";
import lineRight from "static/images/line-right.png";
import lineLeft from "static/images/line-left.png";
import lineVertical from "static/images/line-vertical.png";
import { useMediaQuery } from "react-responsive";
import { bubble as MobileMenu } from "react-burger-menu";
import { subMenuItem } from "../../../apollo/cache";

const MenuWrapper = styled(Flex)`
  min-height: 79px;
  position: relative;
  .bm-burger-button {
    width: 80px;
    height: 36px;
    position: relative;
  }
  .bm-menu {
    width: 100%;
  }
  .bm-menu-wrap,
  .bm-overlay {
    top: 0;
    left: 0;
  }
  .bm-burger-bars {
    background: #000;
  }
`;

const UnorderedList = styled.ul`
  ${(props) => props.mobile && "color: #fff;"}
  list-style: none;
  padding-left: 0;
  display: flex;
  margin: 0;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
`;

const ListItem = styled.li`
  cursor: pointer;
  text-transform: uppercase;
  font-size: 28px;
  padding: 0 5px;
  transform: scale(1);
  transition: transform 0.2s ease-in;
  @media (min-width: 1240px) {
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    &:hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 1239px) {
    margin: 24px 0 6px;
    padding: 0 24px;
  }
`;

const SubListItem = styled.li`
  margin-top: 6px;
  padding: 0 36px;
  font-size: 24px;
`;

const Menu = () => {
  const isDesktop = useMediaQuery({ minWidth: 1240 });
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <Flex width={1} justifyContent="center">
      <MenuWrapper
        width={1}
        maxWidth={"1240px"}
        justifyContent={["center", "center", "space-between"]}
        alignItems={"center"}
      >
        {isDesktop && (
          <>
            <UnorderedList>
              <ListItem>
                <Link to="/naujienos">{"Naujienos"}</Link>
              </ListItem>
              <ImageWrapper src={lineRight} />
              <ListItem>
                <Link to="/repertuaras">{"Repertuaras"}</Link>
              </ListItem>
              <ImageWrapper src={lineLeft} />
              <ListItem>
                <Link to="/spektakliai">{"Spektakliai"}</Link>
              </ListItem>
              <ImageWrapper src={lineRight} />
              <ListItem>
                <Link to="/teatras">{"Teatras"}</Link>
              </ListItem>
              <ImageWrapper src={lineVertical} />
              <ListItem>
                <Link to="/edukacijos">{"Edukacija"}</Link>
              </ListItem>
              <ImageWrapper src={lineLeft} />
              <ListItem>
                <Link to="/festivaliai">{"Baltic Small"}</Link>
              </ListItem>
            </UnorderedList>
            <SocialIcons iconSize={32} />
          </>
        )}
        {!isDesktop && (
          <MobileMenu isOpen={menuOpen} onOpen={() => setMenuOpen(!menuOpen)}>
            <UnorderedList mobile>
              <ListItem>
                <Link to="/naujienos">{"Naujienos"}</Link>
              </ListItem>
              <ListItem>
                <Link to="/repertuaras">{"Repertuaras"}</Link>
              </ListItem>
              <ListItem>
                <Link to="/spektakliai">{"Spektakliai"}</Link>
              </ListItem>
              <ListItem>
                <Link to="/teatras">{"Teatras"}</Link>
              </ListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("administracija");
                    setMenuOpen(false);
                  }}
                >
                  {"Administracija"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("istorija");
                    setMenuOpen(false);
                  }}
                >
                  {"Istorija"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("kontaktai");
                    setMenuOpen(false);
                  }}
                >
                  {"Kontaktai"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("dokumentai");
                    setMenuOpen(false);
                  }}
                >
                  {"Dokumentai"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("remejai");
                    setMenuOpen(false);
                  }}
                >
                  {"Rėmėjai"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("erdves");
                    setMenuOpen(false);
                  }}
                >
                  {"Erdvės"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("trupe");
                    setMenuOpen(false);
                  }}
                >
                  {"Trupė"}
                </Link>
              </SubListItem>
              <SubListItem>
                <Link
                  to="/teatras"
                  onClick={() => {
                    subMenuItem("rezisieriai");
                    setMenuOpen(false);
                  }}
                >
                  {"Režisieriai"}
                </Link>
              </SubListItem>
              <ListItem>
                <Link to="/edukacijos">{"Edukacija"}</Link>
              </ListItem>
              <ListItem>
                <Link to="/festivaliai">{"Baltic Small"}</Link>
              </ListItem>
            </UnorderedList>
            <SocialIcons iconSize={44} />
          </MobileMenu>
        )}
      </MenuWrapper>
    </Flex>
  );
};

export default Menu;
